export default __webpack_public_path__ + "static/media/wen-pepe.199d95bc.jpeg";